var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.content !== 'undefined')?_c('div',{staticClass:"event-child"},[(typeof _vm.content === 'string')?_c('div',{staticClass:"event-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):(_vm.content.length > 0)?_c('Content',{staticClass:"event-content",attrs:{"content":_vm.content}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }